module.exports = __webpack_public_path__ + "img/03-holidays.1c5ee929.png";